export const analyticConfig = {
  paySetting: {
    cid: 'c_x8e1p7p',
    bid: {
      clickItem: 'b_phajjftk',
      clickNoPassPay: 'b_2h0u44vv',
      showSquence: 'b_pay_48r3h1tl_mv'
    },
    cfcaCert: {
      mc: 'b_pay_dm3482fn_mc',
      mv: 'b_pay_dm3482fn_mv'
    }
  },
  setPassword: {
    cid: 'c_pay_cnc31uvs',
    bid: {
      modifyPassword: 'b_pay_g6ki8eus_mc',
      findPassword: 'b_pay_jf6rw3lq_mc'
    }
  },
  noPassPay: {
    cid: 'c_1ivg8obq',
    bid: {
      setQuota: 'b_d6kdcfgb',
      setToggle: 'b_dbu95p0p'
    }
  },
  bindCard: {
    cid: 'c_5keptfuy',
    bid: 'b_pay_c911lqcf_mc'
  },
  safeguard: {
    mv: 'b_pay_xzzu0hao_mv',
    mc: 'b_pay_xzzu0hao_mc'
  },
  cfcaCertStatus: {
    cid: 'c_pay_hqx8d6ni',
    btnMV: 'b_pay_sjsarcvc_mv',
    btnMC: 'b_pay_sjsarcvc_mc',
    modalMV: 'b_pay_34e49f2o_mv',
    modalMC: 'b_pay_34e49f2o_mc',
    toastMV: 'b_pay_dnwovcwz_mv'
  },
  cfcaCertInfo: {
    cid: 'c_pay_8bjrni2z',
    btnMC: 'b_pay_9dtpwhvd_mc'
  },
  shengxinProducts: {
    oneClickPay: {
      mv: 'b_pay_dj4nyuor_mv',
      mc: 'b_pay_dj4nyuor_mc'
    },
    mtScorePay: {
      mv: 'b_pay_6kbjjuqg_mv',
      mc: 'b_pay_6kbjjuqg_mc'
    },
    deductEntry: {
      mv: 'b_pay_0cz532ar_mv',
      mc: 'b_pay_0cz532ar_mc'
    },
    familyCard: {
      mv: 'b_pay_vcwfucjg_mv',
      mc: 'b_pay_vcwfucjg_mc'
    }
  }
};
